// src/config/api.js
const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8000";
const API_VERSION = "v1";

export const API = {
  // Base URLs
  base: BACKEND_URL,
  api: `${BACKEND_URL}/api/${API_VERSION}`,

  // Auth endpoints
  auth: {
    login: `${BACKEND_URL}/api/${API_VERSION}/auth/login`,
    register: `${BACKEND_URL}/api/${API_VERSION}/auth/register`,
    logout: `${BACKEND_URL}/api/${API_VERSION}/auth/logout`,
    me: `${BACKEND_URL}/api/${API_VERSION}/auth/me`,
    profile: `${BACKEND_URL}/api/${API_VERSION}/auth/profile`,
    addresses: `${BACKEND_URL}/api/${API_VERSION}/auth/addresses`,
    cart: {
      get: `${BACKEND_URL}/api/${API_VERSION}/cart`,
      sync: `${BACKEND_URL}/api/${API_VERSION}/cart/sync`,
      clear: `${BACKEND_URL}/api/${API_VERSION}/cart/clear`,
      migrate: `${BACKEND_URL}/api/${API_VERSION}/auth/cart/migrate`,
    },
  },

  // File endpoints
  files: {
    upload: `${BACKEND_URL}/api/${API_VERSION}/files/upload`,
    get: (fileId) => `${BACKEND_URL}/api/${API_VERSION}/files/${fileId}`,
    download: (fileId) =>
      `${BACKEND_URL}/api/${API_VERSION}/files/${fileId}/download`,
    delete: (fileId) => `${BACKEND_URL}/api/${API_VERSION}/files/${fileId}`,
  },

  // Metal endpoints
  metals: {
    list: `${BACKEND_URL}/api/${API_VERSION}/metals`,
    get: (metalId) => `${BACKEND_URL}/api/${API_VERSION}/metals/${metalId}`,
  },

  // Service endpoints
  services: {
    list: `${BACKEND_URL}/api/${API_VERSION}/services`,
  },

  // Shipping endpoints
  shipping: {
    methods: `${BACKEND_URL}/api/${API_VERSION}/shipping/methods`,
  },

  // Price endpoints
  price: {
    calculate: `${BACKEND_URL}/api/${API_VERSION}/price/calculate`,
  },

  // Order endpoints
  orders: {
    create: `${BACKEND_URL}/api/${API_VERSION}/orders`,
    list: `${BACKEND_URL}/api/${API_VERSION}/orders`,
    get: (orderId) => `${BACKEND_URL}/api/${API_VERSION}/orders/${orderId}`,
    reorder: (orderId) =>
      `${BACKEND_URL}/api/${API_VERSION}/orders/${orderId}/reorder`,
  },

  // Checkout endpoints
  checkout: {
    session: `${BACKEND_URL}/api/${API_VERSION}/checkout/session`,
    status: (sessionId) =>
      `${BACKEND_URL}/api/${API_VERSION}/checkout/status/${sessionId}`,
  },

  // Admin endpoints
  admin: {
    metals: `${BACKEND_URL}/api/${API_VERSION}/admin/metals`,
    orders: `${BACKEND_URL}/api/${API_VERSION}/admin/orders`,
    updateMetal: (metalId) =>
      `${BACKEND_URL}/api/${API_VERSION}/admin/metals/${metalId}`,
    updateOrderStatus: (orderId) =>
      `${BACKEND_URL}/api/${API_VERSION}/admin/orders/${orderId}/status`,
    approveOrder: (orderId) =>
      `${BACKEND_URL}/api/${API_VERSION}/admin/orders/${orderId}/approve`,
    declineOrder: (orderId) =>
      `${BACKEND_URL}/api/${API_VERSION}/admin/orders/${orderId}/decline`,
    markPaid: (orderId) =>
      `${BACKEND_URL}/api/${API_VERSION}/admin/orders/${orderId}/mark-paid`,
  },
};

export default API;
